import type { PaperProps } from '@mui/material';
import MuiPaper from '@mui/material/Paper';
import { forwardRef } from 'react';

const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  return <MuiPaper ref={ref} {...props} />;
});
Paper.displayName = 'Paper';
export default Paper;
